// src/App.jsx
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './routes';
import { DataProvider } from './context/DataContext';
import ErrorBoundary from './components/shared/ErrorBoundary';
import './styles/global.css';

function App() {
  return (
    <DataProvider>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </DataProvider>
  );
}

export default App;
